export const SET_LOADING = 'SET_LOADING'
export const SET_RELOAD = 'SET_RELOAD'
